module.exports = __webpack_public_path__ + "static/media/join.f156f27f.png";